import React from 'react';
import { MobxComponent } from "../../../mobx/components";
import { inject, observer } from "mobx-react";
import { withTranslation, WithTranslation } from "react-i18next";
import { IconSettings, IconClose, IconDelete, IconWrapperRounded, IconKiosk, IconPickup, IconDelivery, IconDineIn, IconArrowForward } from "./icons";
import { ColorPicker, Switch } from "@lib/components";
import { HeaderTitleWrapper, MenuItem, QuickSettingsContainer, QuickSettingsHeaderWrapper, QuickSettingsBodyWrapper, QuickSettingsFooterWrapper, QuickSettingsButton, QuickSettingsItemsContainer, QuickSettingsItemsWrapper, QuickSettingsItemWrapper, ButtonV2, MenuColorHeaderWrapper, MenuColorHeaderTitleWrapper, MenuColorDescription, MenuColorBodyWrapper, MenuColorFormGroup, MenuColorLabel, MenuColorColorPickerWrapper, MenuColorColorPickerText, MenuColorPresetsList, MenuColorPresetsListItem, MenuColorPresetsListItemContent, MenuColorFooterWrapper, MenuToggleContainer, MenuToggleText, MenuServiceTypeContainer, MenuServiceTypeItem, MenuLineSeparator, MenuPublishPlatformContainer, MenuPublishPlatFormItem, MenuPublishPlatFormItemHeader, MenuPublishPlatFormItemHeaderLabel, MenuStatusAlert, MenuStatusAlertText, MenuStatusLabelAvailable, MenuStatusServiceList, MenuStatusServiceListItem, MenuStatusServiceListRow, MenuStatusShowSettingsContainer, MenuStatusShowSettingsText, MenuActionContainer, MenuActionItem } from "./layout.c";
import { CoreUtils } from '@lib/common';
import { MoreActionSideBar } from './more-action-menu';


interface Props extends WithTranslation {
    show?: boolean;
    onHide?: () => void;
    onSave: (color: string) => void;
    onShowSettings?: () => void;
    title?: string;
    value?: string;
    children?: React.ReactNode;
}
interface State {
    color: string;
}

@inject("store") @observer
class MenuMoreActionClass extends MobxComponent<Props, State> {
    constructor(props: Props) {
		super(props);
		this.state = {
            color: props.value || '#000000'
        };
	}

    render() {
        const { store, t} = this.injected;
        const { show, onHide, onSave, title, onShowSettings, children } = this.props;
        const { color } = this.state;
        return (
        <QuickSettingsContainer className={show ? 'active': ''}>
            <MenuColorHeaderWrapper>
                <MenuColorHeaderTitleWrapper>
                    {title || 'Acme Pizza'}
                </MenuColorHeaderTitleWrapper>
                <MenuItem onClick={onHide}><IconClose /></MenuItem>
            </MenuColorHeaderWrapper>
            <MenuColorBodyWrapper style={{minHeight: '50vh', overflowY:'scroll'}}>
                <MenuColorLabel>Select action</MenuColorLabel>
                
                {children ?  children : (
                <MenuActionContainer>
                    <MenuActionItem
                        onClick={() =>  store.setActiveMobileMenu('templates', ['menus'])}>
                        Templates</MenuActionItem>
                    <MenuActionItem
                        onClick={() =>  store.setActiveMobileMenu('menus-upload-service', ['menus'])}>
                        Upload Services</MenuActionItem>
                    <MenuActionItem>Import Menu</MenuActionItem>
                    <MenuActionItem>Export Menu</MenuActionItem>
                    <MenuActionItem
                        onClick={() => store.setActiveMobileModal('desktop-filter-menu')}
                        >Filter Menu</MenuActionItem>
                    <MenuActionItem
                        onClick={() => store.setActiveMobileModal('desktop-printer-settings')}
                    >Printer Settings</MenuActionItem>
                </MenuActionContainer> ) }
            </MenuColorBodyWrapper>
        </QuickSettingsContainer>
        )
    }
}
export const MenuMoreAction = withTranslation()(MenuMoreActionClass);
